<template>
  <b-card header="Delete Account" header-bg-variant="danger" header-text-variant="light">
    <b-alert variant="success" show v-if="isSuccessfulDeleteRequest">
      {{ message }}
    </b-alert>
    <template v-else>
      <p v-if="!scheduled">
        If you would like to close and permanently delete your account, click the button below.
      </p>
      <p v-if="scheduled && scheduledDate" class="mt-2">
        Your account is scheduled for deletion on <strong>{{ scheduledDate }}</strong>.<br>
        If you wish to keep your account, you can cancel the scheduled deletion below.
      </p>
      <b-button v-if="scheduled === false" :disabled="loadingDeleteRequest || isSuccessfulDeleteRequest" variant="outline-danger" @click="showConfirmStep">
        Delete Account
      </b-button>
      <template v-if="scheduled">
        <b-button v-if="isFullMember" variant="outline-warning" @click="cancelSchedule" :disabled="loadingDeleteRequest">
          Cancel Account Deletion
        </b-button>
        <div v-else class="mt-3">
          <p class="text-danger font-weight-bold">
            To cancel this scheduled deletion, please subscribe to one of our premium plans.
          </p>
          <b-button variant="danger" :to="{ name: 'payment-management' }">
            Upgrade Membership
          </b-button>
        </div>
      </template>
      <b-modal ref="confirmStep" title="Confirm Account Deletion" ok-title="Yes, Delete My Account" cancel-title="Cancel" @ok="requestAccountDeletion" :ok-disabled="loadingDeleteRequest || !hasConfirmed" :cancel-disabled="loadingDeleteRequest" hide-header-close>
        <b-form-group label="When would you like your account to be deleted?" label-for="deleteScheduleSelect" class="mb-3">
          <b-form-select
            id="deleteScheduleSelect"
            v-model="deleteSchedule"
            :options="deleteScheduleOptions"
            :disabled="loadingDeleteRequest"
          />
        </b-form-group>
        <b-form-checkbox v-model="hasConfirmed" class="mb-3">
          I understand that this action will permanently delete my CPDme account and all associated data
          <span v-if="deleteSchedule !== 'now'"> after the selected waiting period</span>.
        </b-form-checkbox>
        <p class="text-danger font-weight-bold">
          This cannot be undone. Please confirm you wish to proceed.
        </p>
      </b-modal>
    </template>
  </b-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AccountDeletion",
  data() {
    return {
      loadingDeleteRequest: false,
      isSuccessfulDeleteRequest: false,
      hasConfirmed: false,
      deleteSchedule: '7',
      message:'Your account deletion has been scheduled. You will receive a notification email shortly. If you do not receive an email, please contact our support team.',
      deleteScheduleOptions: [
        { value: 'now', text: 'Immediately' },
        { value: '1', text: 'In 1 day' },
        { value: '7', text: 'In 7 days' },
        { value: '30', text: 'In 30 days' },
      ],
      scheduled: null,
      scheduledDate: null,
      loadingSchedule: true,
    };
  },
  created() {
    this.checkSchedule();
  },
  methods: {
    checkSchedule() {
      this.loadingSchedule = true;
      this.$api.v2.get('user-account/me/scheduled-deletion')
        .then((resp) => {
          this.scheduled = resp.body.scheduled;
          this.scheduledDate = resp.body.scheduledDate;
        })
        .finally(() => {
          this.loadingSchedule = false;
        });
    },
    cancelSchedule() {
      this.loadingDeleteRequest = true;
      this.$api.v2.delete('user-account/me/scheduled-deletion')
        .then(() => {
          this.scheduled = false;
          this.scheduledDate = null;
          this.$success('Cancelled', 'Your scheduled account deletion has been cancelled.');
        })
        .catch((resp) => {
          this.$httpError('Failed to cancel scheduled deletion', resp);
        })
        .finally(() => {
          this.loadingDeleteRequest = false;
        });
    },
    showConfirmStep() {
      this.hasConfirmed = false;
      this.$refs.confirmStep.show();
    },
    requestAccountDeletion(bvModalEvt) {
      if (!this.hasConfirmed) {
        bvModalEvt.preventDefault();
        return;
      }
      this.loadingDeleteRequest = true;
      const today = new Date();
      let payload = {};
      let config = { params: {} };
      if (this.deleteSchedule === 'now') {
        config.params.deleteNow = true;
      } else {
        const days = parseInt(this.deleteSchedule, 10);
        const scheduledDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + days + 1);
        config.params.deleteNow = false;
        config.params.scheduledDate = scheduledDate.toISOString().slice(0, 10);
      }
      this.$api.v2.post('user-account/me/scheduled-deletion', null, config)
        .then((resp) => {

          if(resp.body.message)
          {
            this.message = resp.body.message;
          }
          
          this.isSuccessfulDeleteRequest = true;
          this.$success('Request Sent', 'Your account deletion request has been sent.');
          this.$refs.confirmStep.hide();
        })
        .catch((resp) => {
          this.$httpError('Failed to request account deletion', resp);
        })
        .finally(() => {
          this.loadingDeleteRequest = false;
        });
    },
  },
  computed: {
    ...mapGetters({
      isFullMember: 'authentication/isFullMember',
    }),
  },
};
</script>

<style scoped>
.text-danger {
  color: #dc3545 !important;
}
</style>
